import React, { useEffect, useState } from 'react';
import { Avatar } from '@mui/material';
import { getRoomAvatar } from '../services/ProfilePictures';

export default function PlayerAvatar({ roomId, playerId, name, pictureDataUrl, ...props }) {
    const [profile, setProfile] = useState(null);
    useEffect(() => {
        let alive = true;
        let pending = false;
        let changedWhilePending = false;
        setProfile(null);
        const load = async () => {
            if (!roomId || !playerId || pending) return;
            pending = true;
            try { const data = await getRoomAvatar(roomId, playerId); if (alive) setProfile(data); }
            catch { /* A missing image never blocks chat/gameplay. Retry after recovery. */ }
            finally { pending = false; if (alive && changedWhilePending) { changedWhilePending = false; load(); } }
        };
        const recovered = event => { if (event.detail.ready) load(); };
        const changed = event => {
            if (event.detail?.playerId && event.detail.playerId !== playerId) return;
            if (pending) changedWhilePending = true; else load();
        };
        load();
        window.addEventListener('pwf-profile-picture-changed', changed);
        window.addEventListener('pwf-connection-state', recovered);
        return () => { alive = false; window.removeEventListener('pwf-profile-picture-changed', changed); window.removeEventListener('pwf-connection-state', recovered); };
    }, [roomId, playerId]);
    const initial = profile?.initial && profile.initial !== '?' ? profile.initial : Array.from(name || '?')[0].toUpperCase();
    return <Avatar {...props} src={pictureDataUrl || profile?.pictureDataUrl || undefined} alt={name || initial}>{initial}</Avatar>;
}
